<template>
    <v-container>
        <slot name="top"></slot>
        <v-row>
            <v-col cols="12" class="heading-layout">
                <div v-if="title" class="display-1 page-header">{{ title }}</div>
                <slot name="title"></slot>
                <div v-if="subtitle" class="title page-subheader text--thin">{{ subtitle }}</div>
            </v-col>
        </v-row>
        <slot></slot>
    </v-container>
</template>

<script>
export default {
    name: "PageLayout",
    props: ["title", "subtitle"],
    data() {
        return {};
    },
};
</script>
